import { Fragment } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import { Grid } from '@mui/material';
import ProductAddView from '../../../components/inventory/create/product_add/ProductAddView';

const InventoryProductCreateView = () => {
    const { data:data_opt, loading:loading_opt, error:error_opt, refetch:refetch_opt } = useFetchData(AppURL.InventoryURL+"inventory/product/create/options/list/view/");
    return (
        <Fragment>
            <Grid container spacing={1}>
                <Grid item xl={12} md={12} sm={12} xs={12} lg={12}>
                    <ProductAddView data_opt={data_opt}/>
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default InventoryProductCreateView